import { render } from "./ResultsWrapperMobile.vue?vue&type=template&id=1d8d7b53&scoped=true"
import script from "./ResultsWrapperMobile.vue?vue&type=script&lang=js"
export * from "./ResultsWrapperMobile.vue?vue&type=script&lang=js"

import "./ResultsWrapperMobile.vue?vue&type=style&index=0&id=1d8d7b53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8d7b53"]])

export default __exports__